import { trackSignupSccNetTermsClick } from "@faire/web-api--source/events/signup/click/sccNetTerms";
import { ISoftCreditCheckLimitIncreaseResponse } from "@faire/web-api--source/indigofair/data/ISoftCreditCheckLimitIncreaseResponse";

export enum SccClickType {
  START_SCC = "START_SCC",
  SUBMIT_SCC_AGREEMENT = "SUBMIT_SCC_AGREEMENT",
  SUBMIT_SCC_FORM = "SUBMIT_SCC_FORM",
  START_SHOPPING_SCC_STATE = "START_SHOPPING_SCC_STATE",
  SKIP_SCC_AGREEMENT = "SKIP_SCC_AGREEMENT",
  SKIP_SCC_FORM = "SKIP_SCC_FORM",
}

export const trackSccClick = (
  type: keyof typeof SccClickType,
  sccState?: keyof typeof ISoftCreditCheckLimitIncreaseResponse.IncreaseLimitStatus
) => {
  const clickTypeWithState = `${type}_${sccState}`;
  trackSignupSccNetTermsClick(sccState ? clickTypeWithState : type);
};
